<template>
  <div class="card dashboard-messages">
    <translate tag="h3">Messages</translate>
    <ul>
      <li v-for="update in updates" :key="update.url">
        <img src="@/assets/user-account/notification-review.svg" alt="" />
        <nuxt-link :to="update.url">
          {{ update.text }}
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const reviewsStore = useReviewsStore()
const { $puLocalePath, $t } = useNuxtApp()
const { pendingReviews } = storeToRefs(reviewsStore)

// Updates only showing pending reviews for now
const updates = computed(() => {
  const pendingReviewLinks = pendingReviews.value.map((review) => {
    return {
      text: $t('Add a review for your recent holiday at {campsiteName}.', {
        campsiteName: review.campsiteName,
      }),
      url: $puLocalePath({
        name: 'reviews-post-review-campsite-campsiteSlug',
        params: {
          campsiteSlug: review.campsiteSlug,
        },
        query: {
          verify: review.token,
        },
      }),
    }
  })

  return pendingReviewLinks
})
</script>

<style scoped>
li {
  font-size: var(--body);
  display: flex;
  align-items: center;
  gap: 0.5em;
  color: var(--colour-dark-blue);
  line-height: 1.2;
  margin: 0.5em 0;
}
li img {
  width: 1.25em;
  margin-top: 2px;
  place-self: start;
}
a {
  color: var(--colour-dark-blue);
  text-decoration: none;
}
</style>
